type Item = { price: number; quantity: number };

const sumItem = (accum: number, item: Item) => {
  const result = item.price * item.quantity;
  return accum + result;
};

export const sumCartItems = (objectData: Item[]) =>
  parseFloat(objectData.reduce(sumItem, 0).toFixed(2));

export const calculateDiscount = (price: number, compareToPrice: number | null | undefined) =>
  parseFloat((compareToPrice ? compareToPrice - price : 0).toFixed(2));
